/*
* vue-bootstrap-modal
* Version: 2.10.1
* License: undefined
*/
import Vue from 'vue';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var bodyScrollLock_min = createCommonjsModule(function (module, exports) {
!function(e,t){t(exports);}(commonjsGlobal,function(exports){function i(e){if(Array.isArray(e)){for(var t=0,o=Array(e.length);t<e.length;t++)o[t]=e[t];return o}return Array.from(e)}Object.defineProperty(exports,"__esModule",{value:!0});var l=!1;if("undefined"!=typeof window){var e={get passive(){l=!0;}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e);}function d(t){return u.some(function(e){return !(!e.options.allowTouchMove||!e.options.allowTouchMove(t))})}function c(e){var t=e||window.event;return !!d(t.target)||(1<t.touches.length||(t.preventDefault&&t.preventDefault(),!1))}function o(){setTimeout(function(){void 0!==m&&(document.body.style.paddingRight=m,m=void 0),void 0!==f&&(document.body.style.overflow=f,f=void 0);});}var a="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),u=[],s=!1,v=-1,f=void 0,m=void 0;exports.disableBodyScroll=function(r,e){if(a){if(!r)return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");if(r&&!u.some(function(e){return e.targetElement===r})){var t={targetElement:r,options:e||{}};u=[].concat(i(u),[t]),r.ontouchstart=function(e){1===e.targetTouches.length&&(v=e.targetTouches[0].clientY);},r.ontouchmove=function(e){var t,o,n,i;1===e.targetTouches.length&&(o=r,i=(t=e).targetTouches[0].clientY-v,d(t.target)||(o&&0===o.scrollTop&&0<i||(n=o)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?c(t):t.stopPropagation()));},s||(document.addEventListener("touchmove",c,l?{passive:!1}:void 0),s=!0);}}else {n=e,setTimeout(function(){if(void 0===m){var e=!!n&&!0===n.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;e&&0<t&&(m=document.body.style.paddingRight,document.body.style.paddingRight=t+"px");}void 0===f&&(f=document.body.style.overflow,document.body.style.overflow="hidden");});var o={targetElement:r,options:e||{}};u=[].concat(i(u),[o]);}var n;},exports.clearAllBodyScrollLocks=function(){a?(u.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null;}),s&&(document.removeEventListener("touchmove",c,l?{passive:!1}:void 0),s=!1),u=[],v=-1):(o(),u=[]);},exports.enableBodyScroll=function(t){if(a){if(!t)return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");t.ontouchstart=null,t.ontouchmove=null,u=u.filter(function(e){return e.targetElement!==t}),s&&0===u.length&&(document.removeEventListener("touchmove",c,l?{passive:!1}:void 0),s=!1);}else (u=u.filter(function(e){return e.targetElement!==t})).length||o();};});
});

var bodyScrollLock_min$1 = unwrapExports(bodyScrollLock_min);

/* eslint-disable import/prefer-default-export */
/**
 * Check for transition end support
 * Based on https://gist.github.com/O-Zone/7230245
 * @returns {String}
 */
function transitionEndEvent() {
  const transitions = {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'transitionend',
    OTransition: 'otransitionend'
  };
  const elem = document.createElement('div');

  // eslint-disable-next-line no-restricted-syntax
  for (const t in transitions) {
    if (typeof elem.style[t] !== 'undefined') {
      return transitions[t];
    }
  }
  return undefined;
}

// eslint-disable-next-line import/no-unresolved
var bus = new Vue();

var modalShow = {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false
    };
  },
  mounted() {
    this.register();
  },
  watch: {
    value(value, oldValue) {
      if (value === oldValue) {
        return;
      }
      bus.$emit(value ? 'beforeShow' : 'beforeHide', this);
      setTimeout(() => {
        bus.$emit(value ? 'show' : 'hide', this);
        this.show = value;
      }, 0);
    }
  },
  beforeDestroy() {
    this.unregister();
  },
  activated() {
    this.register();
  },
  deactivated() {
    this.unregister();
  },
  methods: {
    register() {
      if (this.value) {
        setTimeout(() => {
          this.show = this.value;
          bus.$emit('show', this);
        }, 0);
      }
    },
    unregister() {
      bus.$emit('hide', this);
    }
  }
};

//
var script$1 = {
  name: 'Modal',
  mixins: [modalShow],
  inheritAttrs: false,
  props: {
    closeable: {
      type: Boolean,
      default: true
    },
    closeLabel: {
      type: String,
      default: 'Close'
    },
    centered: {
      type: Boolean,
      default: false
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    lg: {
      type: Boolean,
      default: false
    },
    sm: {
      type: Boolean,
      default: false
    },
    dialogCls: {
      type: [Object, Array, String],
      default: undefined
    },
    headerCls: {
      type: [Object, Array, String],
      default: undefined
    },
    titleCls: {
      type: [Object, Array, String],
      default: undefined
    },
    bodyCls: {
      type: [Object, Array, String],
      default: undefined
    },
    footerCls: {
      type: [Object, Array, String],
      default: undefined
    }
  },
  computed: {
    $dialogCls() {
      return [this.dialogCls, {
        'modal-dialog-scrollable': this.scrollable,
        'modal-dialog-centered': this.centered,
        'modal-lg': this.lg,
        'modal-sm': this.sm
      }];
    }
  },
  watch: {
    show: 'toggleBodyClass'
  },
  mounted() {
    this.toggleBodyClass(this.show);
  },
  beforeDestroy() {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('modal-open');
      bodyScrollLock_min$1.enableBodyScroll(this.$el);
    }
  },
  methods: {
    toggleBodyClass(show) {
      if (typeof document !== 'undefined') {
        document.body.classList.toggle('modal-open', show);
      }
      if (show) {
        bodyScrollLock_min$1.disableBodyScroll(this.$el);
      } else {
        bodyScrollLock_min$1.enableBodyScroll(this.$el);
      }
    },
    open() {
      // don't open if its open already, to prevent race-condition when using modal stacking
      if (!this.value) {
        this.$emit('input', true);
      }
    },
    close() {
      this.show = false;
      const eventName = transitionEndEvent();
      if (eventName) {
        const handler = e => {
          if (e.target === e.currentTarget) {
            this.$refs.modal.removeEventListener(eventName, handler, false);
            this.$emit('input', false);
          }
        };
        this.$refs.modal.addEventListener(eventName, handler, false);
      } else {
        // browser doesn't support transitionEnd so just close
        this.$nextTick(() => {
          this.$emit('input', false);
        });
      }
    },
    tryClose() {
      if (this.closeable) {
        this.close();
      }
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.value,
      expression: "value"
    }],
    ref: "modal",
    staticClass: "modal fade",
    class: {
      show: _vm.show
    },
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-modal": "true"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.tryClose.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    class: _vm.$dialogCls,
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header",
    class: _vm.headerCls
  }, [_vm.$scopedSlots.title ? _c('h5', {
    staticClass: "modal-title",
    class: _vm.titleCls
  }, [_vm._t("title")], 2) : _vm._e(), _vm._v(" "), _vm.closeable ? _c('button', {
    staticClass: "close",
    attrs: {
      "aria-label": _vm.closeLabel,
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments);
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]) : _vm._e()]), _vm._v(" "), _vm._t("body-footer", function () {
    return [_vm.$scopedSlots.default ? _c('div', {
      staticClass: "modal-body",
      class: _vm.bodyCls
    }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), _vm.$scopedSlots.footer ? _c('div', {
      staticClass: "modal-footer",
      class: _vm.footerCls
    }, [_vm._t("footer", null, {
      "close": _vm.close
    })], 2) : _vm._e()];
  }, null, {
    bodyCls: _vm.bodyCls,
    footerCls: _vm.footerCls,
    close: _vm.close
  })], 2)])])]);
};
var __vue_staticRenderFns__$1 = [];

/* style */
const __vue_inject_styles__$1 = undefined;
/* scoped */
const __vue_scope_id__$1 = undefined;
/* module identifier */
const __vue_module_identifier__$1 = undefined;
/* functional template */
const __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

//
var script = {
  name: 'ModalBackdrop',
  props: {
    value: {
      type: Boolean,
      default: undefined
    },
    usesBus: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      stack: [],
      show: false
    };
  },
  watch: {
    stack(stack) {
      this.setShow(stack.length > 0);
    },
    value(value) {
      this.setShow(value);
    }
  },
  mounted() {
    if (this.usesBus) {
      bus.$on('show', this.push);
      bus.$on('hide', this.remove);
      this.$once('hook:beforeDestroy', () => {
        bus.$off('show', this.push);
        bus.$off('hide', this.remove);
      });
    }
  },
  methods: {
    push(modal) {
      const {
        stack
      } = this;
      if (stack.indexOf(modal) >= 0) {
        return;
      }
      const [openModal] = stack.slice(-1);
      if (openModal) {
        openModal.close();
        // keep that modal on our stack
        stack.push(openModal);
      }
      stack.push(modal);
    },
    pop() {
      const modal = this.stack.pop();
      if (modal) {
        modal.close();
      }
      this.openFromTop();
    },
    remove(modal) {
      const position = this.stack.indexOf(modal);
      this.stack.splice(position, 1);
      this.openFromTop();
    },
    openFromTop() {
      const [closedModal] = this.stack.slice(-1);
      if (closedModal) {
        closedModal.open();
      }
    },
    setShow(value) {
      if (value !== this.show) {
        this.$nextTick(() => {
          this.show = value;
        });
      }
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.stack.length > 0 || _vm.value,
      expression: "stack.length > 0 || value"
    }],
    staticClass: "modal-backdrop fade",
    class: {
      show: _vm.show
    },
    on: {
      "click": _vm.pop
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

const install = function installVueBootstrapModal(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('modal', __vue_component__$1);
  Vue.component('modal-backdrop', __vue_component__);
};

// Create module definition for Vue.use()
const plugin = {
  install
};

export { __vue_component__$1 as Modal, __vue_component__ as ModalBackdrop, plugin as default, modalShow };
